import { Link } from "react-router-dom";
import { hotTags } from "@/mocks/tags";

export default function TagCloud() {
  return (
    <section className="w-full bg-background-100 border border-background-200 rounded-lg p-6">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
          <i className="ri-fire-line text-lg"></i>
        </span>
        <h2 className="font-heading font-bold text-lg text-foreground-950">热门标签云</h2>
        <span className="text-xs text-foreground-500 ml-1">由运营编辑定期更新</span>
      </div>
      <div className="flex flex-wrap gap-2.5">
        {hotTags.map((tag) => (
          <Link
            key={tag}
            to={`/search?q=${encodeURIComponent(tag)}`}
            className="px-3.5 py-1.5 text-sm rounded-full bg-background-50 border border-background-200 text-foreground-700 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            # {tag}
          </Link>
        ))}
      </div>
    </section>
  );
}